export default __webpack_public_path__ + "images/1d3df3dd24dcc694b9a79dac6955f0cf-toronto_mobile.webp";